import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { dataRoutes } from './dataRoutes';

export default function ViewRoutes() {

    const location = useLocation();
    let currKeyIndex = 0;

    const getRoutes = () => {
        const routes = [];
        for (let i = 0; i < dataRoutes.length; i++) {
            const currRoute = dataRoutes[i];
            if (currRoute.routes === undefined) {
                routes.push(getRouteComponent(currRoute));
            } else {
                for (let j = 0; j < currRoute.routes.length; j++) {
                    routes.push(getRouteComponent(currRoute.routes[j]));
                }
            }
        }
        return routes;
    };

    const getRouteComponent = (route) => {
        currKeyIndex++;
        return (
            <Route key={currKeyIndex} path={route.path}>
                {route.data === undefined
                    ? <route.component />
                    : <route.component data={route.data} />
                }
                <Helmet>
                    <title>{route.title + ' - Koya App'}</title>
                    <meta name='description' content={route.title + ' - Koya App'} />
                </Helmet>
            </Route>
        );
    };

    return (
        <TransitionGroup component='div' className='route--transition-group'>
            <CSSTransition
                key={location.pathname}
                classNames='fade'
                timeout={500}
            >
                <div className='route--transition-wrapper'>
                    <Switch location={location}>
                        {getRoutes()}
                    </Switch>
                </div>
            </CSSTransition>
        </TransitionGroup>
    );
}
